export const FETCH_COST_ANALYSIS_DETAILS =
  'assetOwner/FETCH_COST_ANALYSIS_DETAILS';
export const FETCH_ENTITY_ROOT_INVESTMENTS =
  'assetOwner/FETCH_ENTITY_ROOT_INVESTMENTS';
